<template>
    <AddBtn v-if="firstPath == 'price' && subPath == 'favorite' && !thirdPath" @click="openCoinModal"
        :class="{ isModalOpen: clickCoin }" />
</template>

<script>
import AddBtn from "@/components/button/AddBtn.vue";
// import router from "@/routes";
import { mapState, mapMutations } from "vuex";
// import { mapState } from "vuex";

export default {
    name: "PriceComponent",
    components: {
        AddBtn
    },
    methods: {
        ...mapMutations("coinReg", ["changeCoin"]),

        openCoinModal() {
        if (this.isCoinModalOpen) {
            return;
        }
        this.changeCoin({ state: true });

        this.$router.push({
            name: "PriceFavoriteCoin",
        });
    },
    },
    computed: {
        ...mapState("coinReg", ["clickCoin"]),

        path() {
            return this.$route.path;
        },
        firstPath() {
            return this.path.split("/")[1];
        },
        subPath() {
            return this.path.split("/")[2];
        },
        thirdPath() {
            return this.path.split("/")[3];
        }
    }
}
</script>